import { TFunction } from "i18next"
import { frontendCurrency } from "utils/formatCurrency"
import {
  ImpuestosFormValuesProps,
  RetencionFormValuesProps,
  TYPE_TAXES,
} from "../constant"

export const DETALLES_DOCUMENTOS_COLUMNS = (t: TFunction, tipo: string) => {
  const columns = [
    {
      key: "subtotal",
      header: `${t("validaciones.documentos.detail.taxableBase")}`,
      field: "subtotal",
      body: ({
        subtotal,
      }: ImpuestosFormValuesProps | RetencionFormValuesProps) =>
        subtotal !== undefined ? frontendCurrency(subtotal) : "-",
      bodyClassName: "!tw-text-end",
      alignCol: "right",
    },
    {
      key: "porcentaje",
      header: `${
        tipo === TYPE_TAXES.impuestos
          ? `${t("validaciones.documentos.detail.vat")}`
          : `${t("validaciones.documentos.detail.percentage")}`
      }`,
      field: "porcentaje",
      body: ({
        porcentaje,
      }: ImpuestosFormValuesProps | RetencionFormValuesProps) =>
        porcentaje !== undefined ? `${porcentaje}%` : "-",
      bodyClassName: "!tw-text-end",
      alignCol: "right",
    },
    {
      key: "importe",
      header: `${
        tipo === TYPE_TAXES.impuestos
          ? `${t("validaciones.documentos.detail.vatQuota")}`
          : `${t("validaciones.documentos.detail.amount")}`
      }`,
      field: "importe",
      body: ({
        importe,
      }: ImpuestosFormValuesProps | RetencionFormValuesProps) =>
        importe !== undefined ? frontendCurrency(importe) : "-",
      bodyClassName: "!tw-text-end",
      alignCol: "right",
    },
  ]
  return columns
}
